<template>
	<div>
	  <!-- 面包屑导航 -->
	  <el-breadcrumb separator-class="el-icon-arrow-right">
	    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
	    <el-breadcrumb-item>分销商管理</el-breadcrumb-item>
	  </el-breadcrumb>
	  <el-form :inline="true" :model="searchForm" class="user-search">
	    <el-form-item label="搜索：">
	      <el-input size="small" v-model="searchForm.name" placeholder="分销商名称"></el-input>
	    </el-form-item>
	    <el-form-item label="">
	      <el-select size="small" v-model="searchForm.businessState" placeholder="业务状态">
	        <el-option label="全部" value=""></el-option>
	        <el-option label="正常" value="1"></el-option>
	        <el-option label="暂停" value="0"></el-option>
	      </el-select>
	    </el-form-item>
		<el-form-item label="">
		  <el-select size="small" v-model="searchForm.cooperationState" placeholder="合作状态">
		    <el-option label="全部" value=""></el-option>
		    <el-option label="正常" value="1"></el-option>
		    <el-option label="停止合作" value="0"></el-option>
		  </el-select>
		</el-form-item>
	    <el-form-item>
	      <el-button size="small" type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
	      <el-button size="small" type="primary" icon="el-icon-plus" @click="addDistributor()">添加</el-button>
	    </el-form-item>
	  </el-form>
	  <el-table size="small" :data="distributorlist" highlight-current-row v-loading="loading" border element-loading-text="加载中" style="width: 100%;">
	    <el-table-column sortable prop="id" label="分销商ID" width="200">
	    </el-table-column>
		<el-table-column sortable prop="distributorName" label="分销商名称" width="150">
		</el-table-column>
		<el-table-column sortable prop="linkman" label="联系人" width="150">
		</el-table-column>
		<el-table-column sortable prop="phone" label="联系电话" width="150">
		</el-table-column>
		<el-table-column sortable prop="createDate" label="添加时间" width="150">
		</el-table-column>
		<el-table-column sortable prop="antecedentMoney" label="预付款余额(元)" width="150">
		</el-table-column>
		<el-table-column sortable prop="antecedentMoney" label="预付款余额(元)" width="150">
		</el-table-column>
		<el-table-column sortable prop="businessState" label="业务状态" :formatter="businessStateFormat" width="100">
		</el-table-column>
		<el-table-column sortable prop="cooperationState" label="合作状态" :formatter="cooperationStateFormat" width="150">
		</el-table-column>
		<el-table-column align="center" label="操作" min-width="400">
		  <template slot-scope="distrub">
		    <el-button size="mini" @click="showDetail(distrub.row.id)">查看</el-button>
			<el-button size="mini" @click="startOrStopBusinessState(distrub.row)">
			{{distrub.row.businessState == 1?'账户停用':'账户启用'}}
			</el-button>
			<el-button size="mini" @click="showDetail(distrub.row.id)">
			{{distrub.row.cooperationState == 1?'业务停用':'业务启用'}}
			</el-button>
			<el-button size="mini" @click="settingDis(distrub.row.id)">
			设置
			</el-button>
		  </template>
		</el-table-column>
	  </el-table>
	  <Pagination v-bind:child-msg="pageparm"  @callFather="callFather"></Pagination>
	</div>
</template>

<script>
import Pagination from '../../components/Pagination'
import {searchAllApi,businessStartOrStop} from "../../api/distributor/distributorApi.js"
export default {
	data() {
		return {
			loading: false,
			searchForm: {
				name: '',
				businessState: '',
				cooperationState: ''
			},
			distributorCreateVisible: false,
			distributorForm: {
				distributorName: '',
			},
			distributorlist : [],
			pageparm: {
			  currentPage: 1,
			  pageSize: 15,
			  total: 0
			}
		}
	},
	methods: {
		
		callFather: function(parm){
			this.pageparm.currentPage = parm.currentPage
			this.pageparm.pageSize = parm.pageSize
			this.getData()
		},
		addDistributor:function(){
			this.$router.push({path:"distributorAdd"})
		},
		
		getData(){
			this.loading = true
			let searchParam = {
				page: this.pageparm.currentPage,
				pageSize: this.pageparm.pageSize,
				distributorName: this.searchForm.name,
				businessState: this.searchForm.businessState,
				cooperationState: this.searchForm.cooperationState
			}
			searchAllApi(searchParam).then(ret=>{
				this.loading = false
				this.distributorlist = ret.data.data.list
				this.pageparm.total = ret.data.data.total
			})
		},
		
		businessStateFormat(row, column){
			if(row.businessState == 1){
				return "正常"
			}else if(row.businessState == 0){
				return "暂停"
			}else{
				return "未知"
			}
		},
		
		cooperationStateFormat(row, column){
			if(row.cooperationState == 1){
				return "正常"
			}else if(row.cooperationState == 0){
				return "停止合作"
			}else{
				return "未知"
			}
		},
		
		showDetail(id){
			this.$router.push({
				path:"distributorDetail/" + id
			})
		},
		
		startOrStopBusinessState(record){
			var mesg = ''
			var id = record.id
			if(record.businessState == 1){
				mesg = "确定要停用账户吗?"
			}else{
				mesg = "确定要启用账户吗?"
			}
			this.$alert(mesg, '提示', {
			  confirmButtonText: '确定',
			  }).then(ret=>{
				  if(ret == 'confirm'){
					  businessStartOrStop({id:id}).then(s=>{
						  this.getData()
					  })
				  }
			  })
		},
		
		settingDis(id){
			this.$router.push({
				path:"distributorSetting/"+id
			})
		}
	},
	created() {
	  this.getData()
	},
	components: {
	  Pagination
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/distributor/distributorlist.vue